import { useDidMount } from '@surveycake/rhooks';
import { PageService } from 'app/core/page';
import { ExceptionService } from 'app/core/status';
import React, {
  createContext,
  FC,
  ReactNode,
  useContext,
  useState
} from 'react';
import { SurveyConfig } from './SurveyConfig';

export interface SurveyConfigProviderProps {
  surveyConfig: SurveyConfig;
  children: (initialed: boolean) => ReactNode;
}

const SurveyConfigContext = createContext<SurveyConfig>({} as SurveyConfig);

export function useSurveyConfig() {
  return useContext(SurveyConfigContext);
}

export const SurveyConfigProvider: FC<SurveyConfigProviderProps> = ({
  surveyConfig,
  children
}) => {
  const [isInitialed, setIsInitialed] = useState(false);
  const setPage = PageService.useSetPage();
  const setException = ExceptionService.useSetException();

  /**
   * Initial on did mount phase.
   */
  useDidMount(async () => {
    try {
      await surveyConfig.initial();
      surveyConfig.handleStageFinished(setPage, setException, {
        password: true,
        thirdPartyLogin: true
      });
    } catch (error) {
      setException(error);
    }

    setIsInitialed(true);
  });

  return (
    <SurveyConfigContext.Provider value={surveyConfig}>
      {children(isInitialed)}
    </SurveyConfigContext.Provider>
  );
};
